// extracted by mini-css-extract-plugin
module.exports = {"TemperatureWrapper":"temparature_TemperatureWrapper__3lYd_","TemperatureSymbol":"temparature_TemperatureSymbol__1IW1b"};